<ng-template [ngIf]="field && debug">
    {{ JSON.stringify(field.errors) }} t: {{ field.touched }}  i: {{ field.invalid}}  d: {{ field.dirty }}
</ng-template>

<div *ngIf="!form" class="error-msg">
    <ng-template [ngIf]="field && field.touched && field.invalid">
        <span class="inline-error-text">
            <ng-template [ngIf]="field.errors?.required" [ngIfElse]="invalidFormat">
                <span class="missing-required">
                    {{fieldLabel}} is required.
                </span>
            </ng-template>
            <ng-template #invalidFormat>
                <ng-template [ngIf]="field.errors?.invalidUrl">
                    {{fieldLabel}} has an invalid format.
                </ng-template>
                <ng-template [ngIf]="field.errors?.email">
                    Email has an invalid format.
                </ng-template>
                <ng-template [ngIf]="field.errors?.emailDomain">
                    Email addresses may not use public domains.
                </ng-template>
                <ng-template [ngIf]="field.errors?.min && attrs?.min">
                    Minimum allowed {{attrs?.min}}.
                </ng-template>  
                <ng-template [ngIf]="field.errors?.max && attrs?.max">
                    Max allowed {{attrs?.max}}.
                </ng-template>

                <ng-template [ngIf]="field.errors?.min && !attrs?.min">
                    {{fieldLabel}} is less than the minimum allowed value.
                </ng-template>  
                <ng-template [ngIf]="field.errors?.max && !attrs?.max">
                    {{fieldLabel}} is greater than the maximum allowed value.
                </ng-template>


                <ng-template [ngIf]="field.errors?.checksumValidator">
                    {{fieldLabel}} is invalid.
                </ng-template>
                <ng-template [ngIf]="field.errors?.lei && !field.errors?.pattern">
                    {{fieldLabel}} has an invalid format.
                </ng-template>
                <ng-template [ngIf]="field.errors?.minlength && !customLengthMessage">
                    Length requirement of {{field.errors?.minlength.requiredLength}}
                </ng-template>
                <ng-template [ngIf]="field.errors?.minlength && customLengthMessage">
                    {{customLengthMessageContent}}
                </ng-template>
                <ng-template [ngIf]="field.errors?.appNoSpecialCharValidator">
                    {{fieldLabel}} has an invalid format.
                </ng-template>
                <ng-template [ngIf]="field.errors?.appFirstNameValidator">
                    {{fieldLabel}} has an invalid format.
                </ng-template>
                <ng-template [ngIf]="field.errors?.appLastNameValidator">
                    {{fieldLabel}} has an invalid format.
                </ng-template>
                <ng-template [ngIf]="field.errors?.zipValidator">
                    <ng-template [ngIf]="field.errors?.zipValidator.country === 'ca'">
                        {{fieldLabel}} is invalid (example: A1A 1A1)
                    </ng-template>
                    <ng-template [ngIf]="field.errors?.zipValidator.country === 'us'">
                        {{fieldLabel}} is invalid (examples: 99999 or 99999-9999)
                    </ng-template>
                </ng-template>
                <ng-template [ngIf]="field.errors?.cvvLength">
                    Card Verification Value (CVV) has an invalid format.
                </ng-template>
                <ng-template [ngIf]="field.errors?.cvvLengthAmex">
                    Card Verification Value (CVV) has an invalid format.
                </ng-template>
                <ng-template [ngIf]="field.errors?.ccLength">
                    A {{ field.errors?.ccLength }} digit credit card number is required.
                </ng-template>
                <ng-template [ngIf]="field.errors?.cardNumTypeMismatch">
                    Card Number has an invalid format.
                </ng-template>
                <ng-template [ngIf]="field.errors?.cardExpiration">
                    The credit card you are attempting to use has expired.
                </ng-template>
                <ng-template [ngIf]="field.errors?.invalidFecId">
                    The FEC ID must be 9 alphanumeric characters starting with C, H, S, or P.
                </ng-template>
                <ng-template [ngIf]="field.errors?.appCcNumber">
                    The value in the Card Number is invalid.
                </ng-template>
                <ng-template [ngIf]="field.errors?.mask">
                    {{fieldLabel}} has an invalid format.
                </ng-template>
                <ng-template [ngIf]="field.errors?.validatePhoneNumber">
                    {{fieldLabel}} has an invalid format for the selected country.
                </ng-template>
                <ng-template [ngIf]="field.errors?.appExactMatch">
                    {{fieldLabel}} must match the value entered in {{otherFieldLabel}}
                </ng-template>
                <ng-template [ngIf]="field.errors?.noLeadingTrailingSpaces">
                    {{fieldLabel}} should not contain leading or trailing spaces.
                </ng-template>
                <ng-template [ngIf]="field.errors?.pattern">
                    {{fieldLabel}} has an invalid format.
                </ng-template>
            </ng-template>
        </span>
    </ng-template>
</div>

<div *ngIf="form && !fieldTwo">
    <ng-template [ngIf]="field && field.invalid && form.submitted">
        <span class="inline-error-text">
            <ng-template [ngIf]="field.errors?.required" [ngIfElse]="invalidFormat">
                {{fieldLabel}} is required.
            </ng-template>
            <ng-template #invalidFormat>
                <ng-template [ngIf]="field.errors?.invalidUrl">
                    {{fieldLabel}} has an invalid format.
                </ng-template>
                <ng-template [ngIf]="field.errors?.email">
                    {{fieldLabel}} has an invalid format.
                </ng-template>
                <ng-template [ngIf]="field.errors?.emailDomain">
                    Email addresses may not use public domains.
                </ng-template>

                <ng-template [ngIf]="field.errors?.min && attrs?.min">
                    Minimum allowed {{attrs?.min}}.
                </ng-template>  
                <ng-template [ngIf]="field.errors?.max && attrs?.max">
                    Max allowed {{attrs?.max}}.
                </ng-template>


                <ng-template [ngIf]="field.errors?.min && !attrs?.min">
                    {{fieldLabel}} is less than the minimum allowed value.
                </ng-template>  
                <ng-template [ngIf]="field.errors?.max && !attrs?.max">
                    {{fieldLabel}} is greater than the maximum allowed value.
                </ng-template>


                <ng-template [ngIf]="field.errors?.mask">
                    {{fieldLabel}} has an invalid format.
                </ng-template>
                <ng-template [ngIf]="field.errors?.minlength && fieldLabel !== 'Short Code' && !customLengthMessage">
                    Length requirement of {{field.errors?.minlength.requiredLength}}
                </ng-template>
                <ng-template [ngIf]="field.errors?.minlength && customLengthMessage">
                    {{customLengthMessageContent}}
                </ng-template>
                <ng-template [ngIf]="field.errors?.appNoSpecialCharValidator">
                    {{fieldLabel}} has an invalid format.
                </ng-template>
                <ng-template [ngIf]="field.errors?.appFirstNameValidator">
                    {{fieldLabel}} has an invalid format.
                </ng-template>
                <ng-template [ngIf]="field.errors?.appLastNameValidator">
                    {{fieldLabel}} has an invalid format.
                </ng-template>
                <ng-template [ngIf]="field.errors?.zipValidator">
                    <ng-template [ngIf]="field.errors?.zipValidator.country === 'ca'">
                        {{fieldLabel}} is invalid. (example: A1A 1A1)
                    </ng-template>
                    <ng-template [ngIf]="field.errors?.zipValidator.country === 'us'">
                        {{fieldLabel}} is invalid. (example: 99999 or 99999-9999)
                    </ng-template>
                </ng-template>
                <ng-template [ngIf]="field.errors?.invalidFecId">
                    The FEC ID must be 9 alphanumeric characters starting with C, H, S, or P.
                </ng-template>
                <ng-template [ngIf]="(field.errors?.appShortCodeValidator || (fieldLabel === 'Short Code' && field.errors?.minlength)) && !field.errors?.required">
                    The short code must be 5 or 6 alpha-numeric characters and in the numerical range 20000 - 99999 or 200000 - 999999.
                </ng-template>
                <ng-template [ngIf]="field.errors?.validatePhoneNumber">
                    {{fieldLabel}} has an invalid format for the selected country.
                </ng-template>

                <ng-template [ngIf]="field.errors?.appExactMatch">
                    {{fieldLabel}} must match the value entered in {{otherFieldLabel}}.
                </ng-template>

                <ng-template [ngIf]="field.errors?.noLeadingTrailingSpaces">
                    {{fieldLabel}} should not contain leading or trailing spaces.
                </ng-template>

                <ng-template [ngIf]="field.errors?.pattern">
                    {{fieldLabel}} has an invalid format.
                </ng-template>
                <ng-template [ngIf]="field.errors?.lei && !field.errors?.pattern">
                    {{fieldLabel}} has an invalid format.
                </ng-template>


            </ng-template>
        </span>
    </ng-template>
</div>

<div *ngIf="form && fieldTwo">
    <ng-template [ngIf]="(field.invalid || fieldTwo.invalid) && form.submitted">
        <span class="inline-error-text">
            <ng-template [ngIf]="field.errors?.required && fieldLabel !== 'Short Code'" [ngIfElse]="invalidFormat">
                {{fieldLabel}} is required.
            </ng-template>
            <ng-template #invalidFormat>
                <ng-template [ngIf]="(field.errors?.shortCodeValidator || (fieldLabel === 'Short Code' && field.errors?.minlength))
                || (fieldTwo.errors?.shortCodeValidator || (fieldLabel === 'Short Code' && fieldTwo.errors?.minlength))">
                    The short code must be 5 or 6 numeric characters and in the numerical range 20000 - 99999 or 200000 - 999999.
                </ng-template>
                <ng-template [ngIf]="field.errors?.comparisonValidator || fieldTwo.errors?.comparisonValidator">
                    Please enter a valid range. The 'From' short code must be lower than the 'To' short code.
                </ng-template>
            </ng-template>
        </span>
    </ng-template>
</div>